import { UserCategorySelectionWidget } from 'components/FormWidget';
import ListInputWidget from './ListInputWidget';

const uiSchema = () => ({
  cellphones: {
    'ui:widget': ListInputWidget,
  },
  user_category_id: {
    'ui:widget': UserCategorySelectionWidget,
  },
});

export default uiSchema;
